/*
 * Copyright (c) 2025 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React, { useRef, useEffect, useState } from "react";
import ArgosFlexbox from "../../../components/Containers/ArgosFlexbox";
import { renderUpdateURL } from "../CommonFields";

export interface IProps {
  object: any;
  onDataUpdate: (data: any) => void;
}

const RoarReference = (props: IProps) => {
  const roarIdRef = useRef<HTMLInputElement>(null);
  const roarUrlRef = useRef<HTMLInputElement>(null);
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  
  useEffect(() => {
    if (roarIdRef.current) roarIdRef.current.value = props.object.roarId ?? "";
    if (roarUrlRef.current) roarUrlRef.current.value = props.object.roarUrl ?? "";
  }, [props.object]);

  const inputStyle = {
    width: "100%",
    minWidth: "80px",
    maxWidth: "100%",
    padding: "8px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    minHeight: "48px",
  };

  /**
   * Handle the update of ROAR ID text input field.
   */
  const handleUpdateID = () => {
    props.onDataUpdate({
      roarId: roarIdRef.current?.value ?? "",
    });
  };
  /**
   * Handle the update of ROAR URL text input field.
   */
  const handleUpdateUrl = () => {
    props.onDataUpdate({
      roarUrl: roarUrlRef.current?.value ?? "",
    });
    props.object.roarUrl = roarUrlRef.current?.value ?? "";
  };
  return (
    <ArgosFlexbox vertical style={{ padding: 16 }}>
      <div style={{ flex: 1, minWidth: "auto", display: "flex", alignItems: "center" }}>
        <div style={{ flexGrow: 1 }}>
          <label htmlFor="roarId" style={{ display: "block", marginBottom: "5px", color: "#0173CE" }}>
            ID
          </label>
          <input
            id="roarId"
            type="text"
            ref={roarIdRef}
            defaultValue={props.object.roarId ?? ""}
            onBlur={handleUpdateID}
            style={inputStyle}
          />
        </div>
      </div>
      <div style={{ flex: 1, minWidth: "auto", display: "flex", alignItems: "center" }}>
        <div style={{ flexGrow: 1 }}>
          <label htmlFor="roarUrl" style={{ display: "block", marginBottom: "5px", color: "#0173CE" }}>
            URL
          </label>
          <input
            id="roarUrl"
            type="text"
            ref={roarUrlRef}
            value={props.object.roarUrl ?? ""}
            style={inputStyle}
            disabled={true}
          />
        </div>
        {renderUpdateURL(props.object.roarUrl, handleUpdateUrl, dialogOpen, setDialogOpen, roarUrlRef, error, setError)}
      </div>
    </ArgosFlexbox>
  );
};

export default RoarReference;